import { Component } from '@angular/core';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { ThemeService } from 'src/app/services/theme.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { User } from 'src/app/models/user.model';
import { UserRoleConstants } from 'src/app/constants/AppConstants';
import { CommonServiceService } from 'src/app/services/common-service.service';

@Component({
  selector: 'app-sidebar-salesrep',
  templateUrl: './sidebar-salesrep.component.html',
  styleUrls: ['./sidebar-salesrep.component.scss'],
  animations: [
    trigger('openClose', [
      state('true', style({ marginLeft: '0' })),
      state('false', style({ marginLeft: '-20rem' })),
      transition('false <=> true', animate(500))
    ])
  ],
})
export class SidebarSalesrepComponent  {

  status= true;
  profileSub = false;
  menutoggled = true;
  salesUser: boolean = false;
  userInfo: User = new User();

  constructor(
    public themeService: ThemeService,
    public commonService: CommonServiceService,
    public authService: AuthServiceService
  ) {
    this.salesUser = this.authService.hasRole(UserRoleConstants.SALESREP);
    this.userInfo = this.authService.getUserInfo();
  }


  menuToggle(){
    this.status = !this.status;       
  }

  toggleNavigation(){
    this.menutoggled = !this.menutoggled;
  }

  profileSubmenu(){
    this.profileSub = !this.profileSub;   
  }
  
}
